import React, { useEffect, useState } from "react";
import { Table, Checkbox, Modal, Input } from "antd";
import Image from "../image/Image";
import { get_distributors } from "../../../api/endpoints/distributors";
import { FaImages } from "react-icons/fa";
import { COLORS, Typo } from "../../layout/theme";
import { TableContainer } from "./styles";
import { InfoCircleOutlined } from "@ant-design/icons";

const { info } = Modal;

export default function DistributorsSelectorConfig({
	initialValues,
	onChange,
	clientId,
}) {
	const [distributors, setDistributors] = useState(null);

	useEffect(() => {
		const fetch_distributors = async () => {
			const data = await get_distributors();

			const futureDistributor =
				data.map((d) => ({
					key: d.id,
					...d,
					mails: !initialValues
						? d.mails
						: initialValues?.find((i) => i.id === d.id)?.mails,
					selectedMail: initialValues
						? initialValues?.find((i) => i.id === d.id)?.selectedMail
						: d.email,
					code: initialValues?.find((i) => i.id === d.id)?.code,
					checked: initialValues?.find((i) => i.id === d.id)?.code
						? true
						: false,
					eanAutocomplete: initialValues?.find((i) => i.id === d.id)
						?.eanAutocomplete,
					externalName: initialValues
						? initialValues?.find((i) => i.id === d.id)?.externalName
						: d.externalName,
				})) || [];

			setDistributors(futureDistributor);
		};
		if (clientId) fetch_distributors();
	}, [clientId]);

	useEffect(() => {
		onChange(distributors);
	}, [distributors]);

	const handleChange = (id, check) => {
		const _dis = distributors.map((d) =>
			d.id === id ? { ...d, checked: check } : { ...d }
		);
		setDistributors(_dis);
	};

	const handleAutocompleteChange = (id, check) => {
		const _dis = distributors.map((d) =>
			d.id === id ? { ...d, eanAutocomplete: check } : { ...d }
		);
		const _auxDis = distributors.find((i) => i.id === id);
		setDistributors(_dis);
		if (check) handleInfoEan(_auxDis);
	};

	const handleInfoEan = (dist) => {
		info({
			title: "Hay información que sera sobreescrita al guardar los cambios",
			icon: <InfoCircleOutlined style={{ color: COLORS.Secondary }} />,
			content: `Tenga en cuenta que guardar cambios con esta casilla activa implica que se le asigne a cada producto el código ean para el distribuidor ${dist.name}`,
			okText: "Volver",
		});
	};

	const handleChangeName = (id, value) => {
		const updated = distributors.map((d) =>
			d.id === id ? { ...d, externalName: value } : d
		);
		setDistributors(updated);
	};

	const columns = [
		{
			title: (algo) => {
				return <FaImages style={{ color: COLORS.White }} />;
			},
			dataIndex: "photoUrl",
			key: "photoUrl",
			render: (data) => <Image width={40} height={40} src={data} />,
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Droguería</div>,
			dataIndex: "name",
			key: "name",
		},
		{
			title: () => <div style={{ color: COLORS.White }}>@Mail</div>,
			dataIndex: "mails",
			key: "mail",
			width: "300px",
			render: (value, record, index) => (
				<Typo type="muted" level={6}>
					{record.selectedMail}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre externo</div>,
			dataIndex: "externalName",
			key: "externalName",
			width: "300px",
			render: (_, record) => (
				<Input
					value={record.externalName}
					onChange={(e) => handleChangeName(record.id, e.target.value)}
				/>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Activa</div>,
			dataIndex: "",
			key: "active",
			render: (value, record, index) => (
				<Checkbox
					onChange={(e) => handleChange(record.id, e.target.checked)}
					checked={record.checked}
				/>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Usa EAN</div>,
			dataIndex: "",
			key: "ean",
			render: (value, record, index) => (
				<Checkbox
					disabled={!record.checked}
					onChange={(e) =>
						handleAutocompleteChange(record.id, e.target.checked)
					}
					checked={record.eanAutocomplete}
				/>
			),
		},
	];

	if (!distributors) return <div>Loading...</div>;

	return (
		<TableContainer>
			<Table
				size="small"
				columns={columns}
				dataSource={distributors}
				pagination={false}
			/>
		</TableContainer>
	);
}
